const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default class NewsletterSignup {
  static init() {
    document.querySelectorAll('.js-newsletter_signup-form').forEach(form => {
      const input = form.querySelector('.js-newsletter_signup-email');
      const error = form.querySelector('.js-newsletter_signup-error');
      if (!input || !error) return;

      const showError = (message) => {
        error.textContent = message;
        error.style.display = '';
      };

      const clearError = () => {
        error.textContent = '';
        error.style.display = 'none';
      };

      // Klaviyo's embed script also writes server-side errors into this span and toggles its inline display style.
      const sync = () => {
        const hasError = error.style.display !== 'none' && error.textContent.trim().length > 0;
        if (hasError) {
          input.setAttribute('aria-invalid', 'true');
        } else {
          input.removeAttribute('aria-invalid');
        }
      };

      new MutationObserver(sync).observe(error, {
        attributes: true,
        attributeFilter: ['style'],
        childList: true,
        characterData: true,
        subtree: true,
      });
      sync();

      // Capture phase so this runs before Klaviyo's submit handler and can block invalid submissions.
      form.addEventListener('submit', (event) => {
        const value = input.value.trim();
        let message = '';
        if (!value) {
          message = 'Enter your email address.';
        } else if (!input.checkValidity() || !EMAIL_PATTERN.test(value)) {
          message = 'Enter a valid email address, for example name@example.com.';
        }

        if (message) {
          event.preventDefault();
          event.stopImmediatePropagation();
          showError(message);
          input.focus();
        }
      }, true);

      input.addEventListener('input', () => {
        if (error.style.display !== 'none') clearError();
      });
    });
  }
}
